/* eslint-disable react/display-name */
import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Row,
  UncontrolledTooltip,
  NavLink
} from "reactstrap";

import ReactTable, { ReactTableDefaults } from "react-table";
import "react-table/react-table.css";

import HttpUtil from "../../Util/httpUtil";
import Config from "../../Util/config";

import PesquisaRapida from "../Common/PesquisaRapida";
import PrettyCheckbox from "../Common/PrettyCheckbox";
import TooltippedCel from "../Common/TooltippedCel";
import Pagination from "../../Util/Pagination";

import { AlertasContext } from "../../Providers/Alertas";
import { BlockUiContext } from "../../Providers/BlockUi";

import ImpressoesDetalhes from "../Modais/ImpressoesDetalhes";
import EmissoesExclusao from "../Modais/EmissoesExclusao";
import EmissoesExclusaoTodos from "../Modais/EmissoesExclusaoTodos";
import ErroImpressaoGuiasEmitidas from "../Modais/ErroImpressaoGuiasEmitidas";
import EmissoesES from "../Modais/EmissoesES";
import RemessaBancaria from "../Modais/RemessaBancaria";
import DesmarcarComoPaga from "../Modais/DesmarcarComoPaga";
import ModalAviso from "../Modais/ModalAviso";

import { getVal, formataCurrency, formataData } from "../../BaseFunctions";

import { LogsServiceAPI } from "../../Util/logsService";
import Cookies from "js-cookie";

import "./Emitidas.scss";
import infoImg from "../../Assets/information.jpg";

const isSimulacao = localStorage.getItem("isSimulacao") === "true";
const isPro = localStorage.getItem("isPro") === "true";

let pageSize = 20;

Object.assign(ReactTableDefaults, {
  pageSizeOptions: [20, 25, 50, 100],
  defaultPageSize: 20,
  pageSize: 20,
  minRows: 20,
  // maxRows: 30,
  nextText: "Próxima",
  previousText: "Anterior",
  noDataText: "Nenhum resultado encontrado",
  pageText: "Pág.",
  ofText: "de",
  rowsText: "linhas",
  resizable: true
});

function Emitidas() {
  const [rawData, setRawData] = useState([]);
  const [showData, setShowData] = useState([]);
  const [showDataPagination, setShowDataPagination] = useState([]);
  const [rawDocs, setRawDocs] = useState([]);
  const [rawDocsValorTotal, setRawDocsValorTotal] = useState([]);
  const [rawDocsReceita, setRawDocsReceita] = useState([]);
  const [rawDocsDestinatario, setRawDocsDestinatario] = useState([]);
  const [rawDocsVlPrincipal, setRawDocsVlPrincipal] = useState([]);
  const defaultSorted = [{ id: "intNFE", desc: false }];
  const [detalhes, setDetalhes] = useState({});
  const [strBusca, setStrBusca] = useState("");
  const [blFiltroAtivo, setBlFiltroAtivo] = useState(false);
  const [blShowPesquisaRapida, setBlShowPesquisaRapida] = useState(false);
  const [seES, setSeES] = useState(false);
  const [erroImpressao, setErroImpressao] = useState([]);
  const [urlHomo, setUrlHomo] = useState("");
  const [pageData, setDataPage] = useState("");

  let reactTable = React.createRef();
  let ModalDetalhes = React.createRef();
  let ModalEmissoesExclusao = React.createRef();
  let ModalErroImpressao = React.createRef();
  let ModalImpressaoES = React.createRef();
  let ModalEmissoesExclusaoTodos = React.createRef();
  let ModalRemessaBancaria = React.createRef();
  let ModalDesmarcarComoPaga = React.createRef();

  /* eslint-disable no-unused-vars */
  let onLoading;
  let showInfoMessage;
  let showSuccessMessage;
  let showWarningMessage;
  let showErrorMessage;
  /* eslint-enable no-unused-vars */

  useEffect(() => {
    handleReload();
    const notificar = localStorage.getItem("notificarImpressao");
    if (notificar === "true") {
      showSuccessMessage("Guias emitidas com sucesso!");
    }
    localStorage.setItem("notificarImpressao", false);

    if (
      window.location.hostname == "ec2-34-206-89-100.compute-1.amazonaws.com"
    ) {
      setUrlHomo(
        "http://www.testegnre.pe.gov.br/gnre/portal/GNRE_DisponibilidadeUF.jsp"
      );
    } else {
      setUrlHomo(
        "http://www.gnre.pe.gov.br/gnre/portal/GNRE_DisponibilidadeUF.jsp"
      );
    }
  }, []);

  const handleReload = () => {
    let listaDocs = [];
    let listaDocsValorTotal = [];
    let listaDocsReceita = [];
    let listaDocsDestinatario = [];
    let listaDocsVlPrincipal = [];
    onLoading(true);
    HttpUtil.eco_GET(`${Config.urls.API_URL_BASE}Documento/BuscarEmitidas`)
      .then(response => {
        onLoading(false);
        const { data } = response;

        const rawData = data.map(original => ({
          ...original,
          blSelected: false
        }));
        setRawData(rawData);
        setShowData(rawData);
        setShowDataPagination(rawData);
        // setShowData(rawData.slice(0,10));
        rawData.forEach(el => {
          el.listDocumentosFiscais.forEach(e => {
            listaDocs.push(e.strDocumento);
            listaDocsValorTotal.push(e.vlTotal);
            listaDocsReceita.push(e.strReceita);
            listaDocsDestinatario.push(e.strDestinatario);
            listaDocsVlPrincipal.push(e.vlPrincipal);
          });
        });

        setRawDocs(listaDocs);
        setRawDocsValorTotal(listaDocsValorTotal);
        setRawDocsReceita(listaDocsReceita);
        setRawDocsDestinatario(listaDocsDestinatario);
        setRawDocsVlPrincipal(listaDocsVlPrincipal);
      })
      .catch(() => {
        onLoading(false);
        showErrorMessage("Erro ao carregar dados");
        setRawData([]);
        setShowData([]);
      });
  };

  const onUpdatePesquisaRapida = (data, strBusca, blShow) => {
    setShowData(data);
    setStrBusca(strBusca);
    setBlShowPesquisaRapida(blShow);
  };

  // Inicio - ESV - Teste
  const remessaBancaria = () => {
    let now = new Date();
    let DataHoraAgora =
      now.getDate().toString() +
      (now.getMonth() + 1).toString() +
      now.getFullYear().toString() +
      now.getHours().toString() +
      now.getMinutes().toString() +
      now.getSeconds().toString();
    const selected = showData.filter(x => x.blSelected).map(x => x.id);

    const parametros = {
      idUsuario: 124203,
      uf: "SC",
      lstIdDocumentos: selected,
      banco: "ITAU",
      agencia: "0",
      conta: "0",
      dv: "0"
    };

    // HttpUtil.eco_POST(`${Config.urls.API_URL_BASE}documento/RemessaBancaria`, parametros)
    // 	.then(response => {
    // 		const { data } = response;
    // 		var bytes = new Uint8Array(data.length);

    // 		for (let i = 0; i < data.length; i++) {
    // 			bytes[i] = data.charCodeAt(i);
    // 		}

    // 		const element = document.createElement("a");
    // 		const file = new Blob([bytes.buffer], { type: 'text/plain' });
    // 		element.href = URL.createObjectURL(file);
    // 		element.download = "RemessaBancaria_" + parametros.banco + "_" + DataHoraAgora + ".txt";
    // 		document.body.appendChild(element);
    // 		element.click();
    // 	})
    // 	.catch(() => {
    // 		/*onLoading(false);*/
    // 		showErrorMessage('Ocorreu um erro ao obter o txt da remessa bancária');
    // 	});
  };
  // Termino - ESV - Teste

  const textFilterMethod = (filter, row) =>
    row[filter.id] &&
    row[filter.id].toLowerCase().indexOf(filter.value.toLowerCase()) > -1;

  const textFilterSituacao = (filter, row) => {
    if (filter.value.toLowerCase() == "impresso") {
      return (
        row[filter.id] &&
        row[filter.id].toLowerCase().indexOf(filter.value.toLowerCase()) > -1
      );
    }

    if (filter.value.toLowerCase() == "não impresso") {
      let teste = "Sucesso";
      return (
        row[filter.id] &&
        row[filter.id].toLowerCase().indexOf(teste.toLowerCase()) > -1
      );
    }
  };

  const dateFilterMethod = (filter, row) =>
    row[filter.id] &&
    new Date(row[filter.id]).toLocaleDateString().indexOf(filter.value) > -1;

  const childPaginationValue = page => {
    setDataPage(page);
  };

  const handleTableSelectAllChange = ({ target: { checked } }) => {
    const firstPageIndex = (pageData - 1) * pageSize;
    const lastPageIndex = firstPageIndex + pageSize;

    const dadosLista = showData.slice(firstPageIndex, lastPageIndex);

    let listaPaginada = dadosLista.map(original => ({
      ...original,
      blSelected: checked
    }));

    const valor = rawData.map(row => {
      listaPaginada.map(el => {
        if (row.id == el.id) {
          row.blSelected = el.blSelected;
        }
      });
      return row;
    });

    setShowDataPagination(valor);
    setShowData(valor);

    setShowDataPagination(
      valor.map(original => ({ ...original, blSelected: checked }))
    );
    //setShowData(valor.map(original => ({ ...original, blSelected: checked })));
    // console.log(rawData.slice(0, ReactTableDefaults.minRows))
  };

  const handleTableSelectChange = (row, target) => {
    setShowData([
      ...showData.slice(0, row.index),
      { ...row.original, [target.name]: target.checked },
      ...showData.slice(row.index + 1)
    ]);
  };

  const logImpressao = () => {
    // Pega log ao imprimir a guia e envia para o Painel de Acessos do Principal
    let logsServiceApi = new LogsServiceAPI();
    logsServiceApi.salvarLog(Cookies.get("bG9naW4"), 353, 3);
  };

  const imprimirSelecionadas = (id = null) => {
    onLoading(true);
    logImpressao();
    if (id != null && id.uf == "ES" && seES == false) {
      ModalImpressaoES.current.openModal();
      setSeES(true);
    } else {
      setSeES(false);
    }
    const selected =
      id != null ? [id.id] : showData.filter(x => x.blSelected).map(x => x.id);

    if (selected != null) {
      HttpUtil.eco_POST_CONFIG(
        `${Config.urls.API_URL_BASE}Documento/Imprimir`,
        selected,
        {
          headers: {
            Authorization: `bearer ${localStorage.getItem("AccessToken")}`
          }
        }
      )
        .then(response => {
          const { data } = response;
          var binary = window.atob(data.resposta);
          var len = binary.length;
          var bytes = new Uint8Array(len);
          for (let i = 0; i < len; i++) {
            bytes[i] = binary.charCodeAt(i);
          }
          const file = new Blob([bytes.buffer], { type: "application/pdf" });
          if (data.resposta !== "") {
            if (data.erro) {
              setErroImpressao(data.erro);
            }
            onLoading(false);
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            const fileURL = URL.createObjectURL(file);
            window.open(fileURL);
            handleReload();
          } else {
            onLoading(false);
            ModalErroImpressao.current.openModal();
          }
        })
        .catch(() => {
          onLoading(false);
          showErrorMessage("Ocorreu um erro ao obter o pdf da receita");
        });
    }
  };

  useEffect(() => {
    if (erroImpressao.length > 0) {
      ModalErroImpressao.current.openModal();
    }
  }, [erroImpressao]);

  useEffect(() => {
    detalhes.id && ModalDetalhes.current.openModal();
  }, [detalhes]);

  const MostrarModalDetalhes = (id, recibo, status) => {
    onLoading(true);

    var url = `${Config.urls.API_URL_BASE}Documento/BuscarDetalhes/${id}`;

    HttpUtil.eco_GET(url).then(response => {
      setDetalhes({ guias: [] });

      if (response.data.length > 0) {
        setDetalhes({
          id: id,
          razaoSocial: response.data[0].razaoSocial,
          documento: response.data[0].documentoDestinatario,
          guias: response.data,
          status
        });
        onLoading(false);
      }
    });
  };

  const validarShowRemessaBancaria = showData => {
    if (showData.length > 1) {
      let cnpj = showData.map(a => a.cnpjEmissor);
      let status = showData.map(a => a.status);
      let controle = false;
      cnpj.forEach(item => {
        if (item != cnpj[0]) {
          controle = true;
        }
      });
      status.forEach(item => {
        if (item === "ArquivoGerado" || item === "Paga") {
          controle = true;
        }
      });
      return controle;
    }
    return true;
  };

  const mostrarDestacados = (row, valor, tooltip = false) => {
    let newValor = valor;
    switch (valor) {
      case "Sucesso":
        newValor = "Não Impresso";
        break;
      case "ArquivoGerado":
        newValor = "Arquivo Gerado";
        break;
    }
    return (
      <div
        className={`row-mostrar-destacados ${
          row.original.status === "Sucesso" ? "sucesso" : ""
        }`}
      >
        {tooltip ? <TooltippedCel text={newValor} /> : newValor}
      </div>
    );
  };

  const alternarPagamento = ({ id, uf, estaPago, motivo }) => {
    // Lida com IDs negativos
    if (id < 0) {
      id *= -1;
    }
    //
    onLoading(true);
    HttpUtil.eco_PUT(
      `${Config.urls.API_URL_BASE}Documento/Guia/PagamentoStatus`,
      {
        idDocumento: id,
        uf: uf,
        flagPago: !estaPago,
        motivo: motivo || null
      }
    )
      .then(() => {
        onLoading(false);
        handleReload();
      })
      .catch(() => {
        onLoading(false);
      });
  };

  const lidarComAlteracaoPagamento = ({ id, uf, estaPago }) => {
    if (!estaPago) {
      alternarPagamento({ id, uf, estaPago });
      return;
    }
    if (ModalDesmarcarComoPaga.current) {
      ModalDesmarcarComoPaga.current.abrirModal({ id, uf, estaPago });
    }
  };

  const imprimirFiltro = () => {
    const notNullid = showData.filter(x => x.blSelected).map(x => x.uf);
    for (const uf of notNullid) {
      if (uf == "ES" && !seES) {
        ModalImpressaoES.current.openModal();
        setSeES(true);
      }
    }
    imprimirSelecionadas();
  };

  const habilitarImpressao = row => (
    <Row>
      {row.original.status !== "Paga" && (
        <Col
          className="nav-item m-0"
          onClick={() => imprimirSelecionadas(row.original)}
        >
          <span id={"printTip" + row.original.id}>
            <i className="fas fa-print" />
          </span>
          <UncontrolledTooltip
            placement="top"
            target={"printTip" + row.original.id}
          >
            Imprimir
          </UncontrolledTooltip>
        </Col>
      )}
      <Col
        className="nav-item m-0"
        onClick={() =>
          MostrarModalDetalhes(
            row.original.id,
            row.original.recibo,
            row.original.status
          )
        }
      >
        <span id={"detailTip" + row.original.id}>
          <i className="fas fa-file-alt" />
        </span>
        <UncontrolledTooltip
          placement="top"
          target={"detailTip" + row.original.id}
        >
          Detalhes
        </UncontrolledTooltip>
      </Col>
      {row.original.status !== "Sucesso" && (
        <Col
          className="nav-item m-0"
          onClick={() =>
            lidarComAlteracaoPagamento({
              id: row.original.id,
              uf: row.original.uf,
              estaPago: row.original.status === "Paga"
            })
          }
        >
          <span
            id={`check-${row.original.id}`}
            className={`${row.original.status === "Paga" ? "marcarPaga" : ""}`}
          >
            <i className="fas fa-check-square" />
          </span>
          <UncontrolledTooltip
            placement="top"
            target={`check-${row.original.id}`}
          >
            {row.original.status === "Paga"
              ? "Desmarcar como paga"
              : "Marcar como paga"}
          </UncontrolledTooltip>
        </Col>
      )}
    </Row>
  );

  const renderDocumentosFiscais = row => {
    const listDocumentosFiscais =
      getVal(row, "original.listDocumentosFiscais") || [];

    const columnsDocFiscais = [
      {
        Header: () => <div className="text-left">N. DOCUMENTO</div>,
        accessor: "strDocumento",
        className: "text-left",
        width: 100,
        Cell: row =>
          row.value.length >= 35
            ? parseInt(row.value.substring(25, 34))
            : row.value
      },
      {
        Header: () => <div className="text-left">TIPO</div>,
        accessor: "strTipoNota",
        className: "text-left",
        width: 50
      },
      {
        Header: () => <div className="text-left">DESTINATÁRIO</div>,
        accessor: "strDestinatario",
        className: "text-left",
        Cell: row => <TooltippedCel text={row.value} />
      },
      {
        Header: "RECEITA",
        accessor: "strReceita",
        className: "text-center",
        width: 80
      },
      {
        Header: "FCP",
        accessor: "receitaFcp",
        className: "text-center",
        width: 60,
        Cell: row => {
          const infoFCP_id = `info-fcp-id-${new Date().getTime()}`;

          return (
            <div>
              {row.value}
              {row.original.receitaFcp === "Não" && row.original.vlFcp > 0 ? (
                <span>
                  &nbsp;
                  <i id={infoFCP_id} className="fas fa-info-circle text-info" />
                  <UncontrolledTooltip placement="right" target={infoFCP_id}>
                    A guia de FCP deverá ser emitida diretamente no Portal da
                    SEFAZ, relativo ao estado
                  </UncontrolledTooltip>
                </span>
              ) : null}
            </div>
          );
        }
      },
      {
        Header: "PRINCIPAL",
        accessor: "vlPrincipal",
        className: "text-center",
        Cell: row => formataCurrency(row.value),
        width: 100
      },
      {
        Header: "MULTA",
        accessor: "vlMulta",
        className: "text-center",
        Cell: row => formataCurrency(row.value),
        width: 100
      },
      {
        Header: "JUROS",
        accessor: "vlJuros",
        className: "text-center",
        Cell: row => formataCurrency(row.value),
        width: 100
      },
      {
        Header: "VALOR TOTAL",
        accessor: "vlValor",
        className: "text-center",
        Cell: row => formataCurrency(row.value),
        width: 150
      }
    ];

    if (row.original.status === "ArquivoGerado") {
      columnsDocFiscais.push({
        Header: () => <div className="text-left">Banco</div>,
        // accessor: 'strDocumento',
        className: "text-left",
        width: 100,
        Cell: <div>{row.original.remessaBancaria.banco}</div>
      });
    }

    return (
      <Card className="documentos-fiscais">
        <CardHeader>DOCUMENTOS FISCAIS</CardHeader>
        <CardBody>
          <ReactTable
            data={listDocumentosFiscais}
            filterable={false}
            columns={columnsDocFiscais}
            showPagination={false}
            defaultSorted={[{ id: "strEmitente", desc: false }]}
            minRows={1}
          />
        </CardBody>
      </Card>
    );
  };

  const columns = [
    {
      Header: () => <div />,
      expander: true,
      // eslint-disable-next-line react/prop-types
      Expander: ({ isExpanded }) => (
        <div>
          {isExpanded ? (
            <i className="fas fa-minus" />
          ) : (
            <i className="fas fa-plus" />
          )}
        </div>
      )
    },
    {
      Header: () => (
        <div className="text-center">
          <PrettyCheckbox
            strTitle="Essa opção seleciona todos os documentos existentes nesse grupo e não somente a quantidade exibida."
            checked={showDataPagination.every(original => original.blSelected)}
            id="selectAll"
            onChange={e => handleTableSelectAllChange(e)}
            // onChange={() => toggleAllPageRowsSelected()}
            iconSuccess="fas fa-check-double"
            simpleSelection
          />
        </div>
      ),
      accessor: "blSelected",
      Cell: row => (
        <PrettyCheckbox
          strTitle="Selecionar"
          checked={row.original.blSelected}
          id="blSelected"
          onChange={({ target }) => handleTableSelectChange(row, target)}
          iconSuccess="fas fa-check"
          simpleSelection
        />
      ),
      filterable: false,
      sortable: false,
      className: "text-center",
      width: 35
    },
    {
      Header: () => <div className="text-left">Emitente</div>,
      accessor: "razaoSocialEmissor",
      filterMethod: textFilterMethod,
      className: "text-left",
      Cell: row => mostrarDestacados(row, row.value, true)
    },
    {
      Header: "Pagamento",
      accessor: "data",
      filterMethod: dateFilterMethod,
      className: "text-center",
      Cell: row => mostrarDestacados(row, formataData(row.value), false),
      width: 115
    },
    {
      Header: "UF DESTINO",
      accessor: "uf",
      filterMethod: textFilterMethod,
      className: "text-center",
      width: 100
    },
    {
      Header: "Valor",
      accessor: "valorTotal",
      filterMethod: (filter, row) =>
        row[filter.id] && row[filter.id].toString().includes(filter.value),
      className: "text-center",
      width: 100,
      Cell: row => mostrarDestacados(row, formataCurrency(row.value))
    },
    {
      Header: "Situação",
      accessor: "status",
      filterMethod: textFilterSituacao,
      className: "text-center",
      width: 150,
      Cell: row => mostrarDestacados(row, row.value)
    },
    {
      Header: "",
      className: "text-center",
      filterable: false,
      sortable: false,
      width: 80,
      Cell: row => habilitarImpressao(row)
    }
  ];

  return (
    <main id="emitidas">
      <AlertasContext.Consumer>
        {alertas => {
          showInfoMessage = alertas.info;
          showSuccessMessage = alertas.success;
          showWarningMessage = alertas.warning;
          showErrorMessage = alertas.error;
        }}
      </AlertasContext.Consumer>
      <BlockUiContext.Consumer>
        {blockUi => {
          onLoading = blockUi.handleLoading;
        }}
      </BlockUiContext.Consumer>
      <DesmarcarComoPaga
        ref={ModalDesmarcarComoPaga}
        onClosed={handleReload}
        alternarPagamento={alternarPagamento}
      />
      <ImpressoesDetalhes
        ref={ModalDetalhes}
        value={detalhes}
        onClosed={handleReload}
      />
      <ErroImpressaoGuiasEmitidas
        ref={ModalErroImpressao}
        listErro={erroImpressao}
        onClosed={handleReload}
      />
      <EmissoesES ref={ModalImpressaoES} />
      <EmissoesExclusao
        ref={ModalEmissoesExclusao}
        value={showData.filter(x => x.blSelected).map(x => x.id)}
        onClosed={handleReload}
      />
      <EmissoesExclusaoTodos
        ref={ModalEmissoesExclusaoTodos}
        value={showData.map(x => x.id)}
        status={4}
        onClosed={handleReload}
      />
      <Row noGutters id="main-header">
        <Col>
          {/*<Row>*/}
          {/*	<Col className="alert alert-danger">*/}
          {/*		<strong>AVISO</strong>:O EcoGNRE está passando por instabilidade, nossa equipe técnica está trabalhando para normalizar o quanto antes.*/}
          {/*		Enquanto isto, a emissão pode ser realizada através do link: https://www.gnre.pe.gov.br:444/gnre/portal/GNRE_Principal.jsp*/}
          {/*	</Col>*/}
          {/*</Row>*/}

          <Row
            style={{
              display: "flex",
              justifyContent: "spaceBetween",
              alignItems: "center",
              flexWrap: "wrap",
              padding: "10px",
              gap: "10px"
            }}
          >
            <Col style={{ flex: "0.7 1 0%", minWidth: "100px" }}>
              <h1>Guias emitidas</h1>
            </Col>
            {/* <Col style={{ flex: '2 1 0%', 'minWidth': '100px' }}>
							<NavLink
								href="https://auditor.econeteditora.com.br/validar-login"
								className="btn btn-secondary"
								target="_blank"
								style={{ padding: '4px 10px 1px 10px', fontSize: 'small' }}>
								Para gerar a <b>GNRE por Apuração</b>, favor auditar o arquivo TXT através do <b>Auditor Fiscal</b>
							</NavLink>
						</Col>
						<Col style={{ flex: '1 1 0%', 'minWidth': '100px' }}>
							<NavLink
								href={urlHomo}
								className="btn btn-secondary"
								target="_blank"
								style={{ padding: '4px 10px 1px 10px', fontSize: 'small' }}>
								<>Verificar disponibilidade de emissão por UF </>
								<i className="fas fa-info-circle" />
							</NavLink>
						</Col> */}
          </Row>
          <Row noGutters>
            <Col className="singleHeaderHeight">
              <Container id="buttons" className="p-0">
                <Row>
                  <Col xs="auto p-0">
                    <Button
                      size="sm"
                      color="primary"
                      block
                      // onClick={() => imprimirSelecionadas()}
                      onClick={() => imprimirFiltro()}
                      disabled={
                        !isSimulacao
                          ? !showData.some(original => original.blSelected)
                          : "false"
                      }
                    >
                      <i className="fas fa-print" /> Imprimir
                    </Button>
                  </Col>
                  {/*Inicio - ESV - Teste*/}
                  <Col xs="auto p-0">
                    <Button
                      data-toggle="tooltip"
                      data-placement="top"
                      data-html="true"
                      title="Gerar remessa bancária: Para habilitar a remessa bancária, é necessário selecionar, no mínimo, dois registros do mesmo emitente."
                      onClick={() => ModalRemessaBancaria.current.openModal()}
                      size="sm"
                      className="btn-alert"
                      block
                      disabled={
                        !isSimulacao && !isPro
                          ? validarShowRemessaBancaria(
                              showData.filter(x => x.blSelected)
                            )
                          : "false"
                      }
                    >
                      <i className="fas fa-print" /> Gerar remessa bancária
                    </Button>
                  </Col>
                  {/*Termino - ESV - Teste*/}
                  <Col xs="auto p-0">
                    <Button
                      onClick={() => ModalEmissoesExclusao.current.openModal()}
                      size="sm"
                      color={`base-class ${
                        showData.some(original => original.blSelected)
                          ? "btn-info"
                          : "btn-secondary"
                      }`}
                      block
                      disabled={
                        !isSimulacao && !isPro
                          ? !showData.some(original => original.blSelected)
                          : "false"
                      }
                    >
                      <i className="fas fa-trash-alt" /> Excluir
                    </Button>
                  </Col>
                  <Col xs="auto p-0">
                    <Button
                      onClick={() =>
                        ModalEmissoesExclusaoTodos.current.openModal()
                      }
                      size="sm"
                      color={`base-class btn-danger`}
                      block
                      disabled={showData.length <= 0}
                    >
                      <i className="fas fa-trash-alt" /> Excluir Todas as Guias
                    </Button>
                  </Col>
                </Row>
              </Container>
            </Col>
            <Col
              xs="12"
              xl="4"
              className="singleHeaderHeight mobile-buttons m-2"
            >
              {blShowPesquisaRapida ? (
                <PesquisaRapida
                  value={strBusca}
                  blShow={blShowPesquisaRapida}
                  rawData={rawData}
                  rawDocs={rawDocs}
                  rawDocsValorTotal={rawDocsValorTotal}
                  rawDocsReceita={rawDocsReceita}
                  rawDocsDestinatario={rawDocsDestinatario}
                  rawDocsVlPrincipal={rawDocsVlPrincipal}
                  onUpdate={onUpdatePesquisaRapida}
                />
              ) : (
                <Container className="p-0">
                  <Row>
                    <Col />
                    <Col xs="auto p-0">
                      <Button
                        onClick={() => {
                          setBlFiltroAtivo(!blFiltroAtivo);
                          setShowData(rawData);
                          setStrBusca("");
                        }}
                        color="link"
                      >
                        <i className="ecoico ecoico-filtro" />
                      </Button>
                    </Col>
                    <Col xs="auto p-0">
                      <Button
                        onClick={() => {
                          setBlShowPesquisaRapida(true);
                          setBlFiltroAtivo(false);
                        }}
                        color="link"
                      >
                        {strBusca ? (
                          <i className="fas fa-search-plus" />
                        ) : (
                          <i className="fas fa-search" />
                        )}
                      </Button>
                    </Col>
                  </Row>
                </Container>
              )}
            </Col>
          </Row>
        </Col>
      </Row>
      <Row noGutters>
        <Col>
          <ReactTable
            className="table-emitidas"
            ref={reactTable}
            data={showData}
            filterable={blFiltroAtivo}
            columns={columns}
            showPagination={showData.length > 0}
            showPageSizeOptions={false}
            selectAll={false}
            PaginationComponent={Pagination}
            childPaginationValue={childPaginationValue}
            SubComponent={row => renderDocumentosFiscais(row)}
            // collapseOnDataChange={false}
            strTableInfo="Guias"
          />
        </Col>
      </Row>
      <RemessaBancaria
        ref={ModalRemessaBancaria}
        value={showData.filter(x => x.blSelected)}
        onClosed={handleReload}
      />
      <ModalAviso />
    </main>
  );
}

export default withRouter(Emitidas);
